export default __webpack_public_path__ + "static/media/civic-round-image.eab0f74f.png";